export default __webpack_public_path__ + "static/media/Calendar.235cfea5.svg";